import useCustomer from "../../../hooks/useCustomer"
import useLiveProducts from "../../../shopify/useLiveProducts"
import useAllProducts from "../../../hooks/useAllProducts"
import { useQuery } from "@tanstack/react-query"

const variantIdPrefix = "gid://shopify/ProductVariant/"

const useMyWishlist = () => {
  const customer = useCustomer()
  const liveProducts = useLiveProducts()
  const allSSRProducts = useAllProducts()

  const query = useQuery({
    queryKey: ["wishlist"],
    queryFn: async () => {
      const res = await fetch("/api/get-wishlist", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ownerId: customer?.id,
        }),
      })

      return await res.json()
    },
  })

  const findProductFromVariant = variantId => {
    const product = liveProducts?.find(item => {
      return item.variants.edges.find(variant => {
        return variant.node.id.replace(variantIdPrefix, "") === variantId
      })
    })

    const variant = product?.variants?.edges?.find?.(item => {
      return item.node.id.replace(variantIdPrefix, "") === variantId
    })

    const ssrProduct = allSSRProducts?.find(ssrProd => {
      return ssrProd.shopifyId === product?.id
    })

    const url = ssrProduct?.wpProduct?.uri

    if (!ssrProduct || !product || !variant || !url) {
      return null
    }

    return {
      variant,
      product,
      url,
      featuredImage: ssrProduct?.media?.[0]?.preview?.image,
      ssrProduct,
    }
  }

  const parsedWishlist = query?.data?.wishlist?.value
    ? JSON.parse(query?.data?.wishlist?.value)?.map?.(item =>
        item.replace(variantIdPrefix, "")
      )
    : []

  const wishlist = parsedWishlist
    ?.map?.(variantId => {
      return findProductFromVariant(variantId)
    })
    ?.filter(item => item)

  const updateWishlist = newWishlist => {
    fetch("/api/update-wishlist", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        ownerId: customer?.id,
        wishlist: newWishlist,
      }),
    }).then(() => {
      query.refetch() // this invalidates the query and refetches it
    })
  }

  const addToWishlist = variantId => {
    const newWishlist = [
      ...new Set(
        (wishlist?.map(item => item.variant.node.id) || []).concat(variantId)
      ),
    ]

    updateWishlist(newWishlist)
  }
  const removeFromWishlist = variantId => {
    const newWishlist =
      wishlist
        ?.map(item => item.variant.node.id)
        ?.filter(id => id !== variantId) || []

    updateWishlist(newWishlist)
  }

  return {
    wishlist,
    loading: query.isLoading,
    addToWishlist,
    removeFromWishlist,
    updateWishlist,
  }
}

export default useMyWishlist
